import { render, staticRenderFns } from "./AcademyTabOverview.vue?vue&type=template&id=c4722ee4&scoped=true&"
import script from "./AcademyTabOverview.vue?vue&type=script&lang=js&"
export * from "./AcademyTabOverview.vue?vue&type=script&lang=js&"
import style0 from "./AcademyTabOverview.vue?vue&type=style&index=0&id=c4722ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4722ee4",
  null
  
)

export default component.exports